import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { BACKEND, API_PERU_URL, API_PERU_TOKEN } from "../config/configEnvs"
import axios from "axios"
import { FaBarcode, FaBirthdayCake, FaBox, FaCheck, FaExternalLinkAlt, FaIdCard, FaIdCardAlt, FaMoneyBillAlt, FaNetworkWired, FaPhoenixFramework, FaPhone, FaSuitcase, FaTimes, FaTrash, FaUser, FaUserCircle, FaVoicemail } from "react-icons/fa"
import { Button } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import PaginationItem from "../components/ui/components/Pagination"
import ItemRowLead from "../components/TrackeoLeads/ItemRowLead"
import AddIcon from "@mui/icons-material/Add";
import Modal from "../components/ui/Modal"
import Tooltip from "../components/ui/ToolTip"

import 'tippy.js/dist/tippy.css';
import { FaMoneyBillTrendUp } from "react-icons/fa6"
import FormLoader from "../components/ui/FormLoader"
import { ExportarColeccionExcel } from "../utils/automateFuncions/ExportarColeccionExcel"
import { useSelector } from "react-redux"
import GetCountries from "../utils/getData/GetCountries"

const TrackeoLeads = () => {

  const user = useSelector((state) => state.auth.user)
  const isSuperAdmin = user.area.toUpperCase() === "ADMINISTRACION" && (user.puesto.toUpperCase() === "GERENTE GENERAL" || user.area.toUpperCase() === "JEFE DE PROYECTOS")

  const [limit, setLimit] = useState(20) // Límite
  const [page, setPage] = useState(1) // Página
  const [totalDocs, setTotalDocs] = useState(0) // Documentos totales
  const [totalPages, setTotalPages] = useState(0) // Pagionas totales

  const [countryNames, setCountryNames] = useState([])

  useEffect(() => {
    GetCountries({setter: setCountryNames})
  }, [])

  useEffect(() => {
    getLeads()
    getWorkers()
  }, [])

  const [workers, setWorkers] = useState([]) // Trabajadores
  const [leads, setLeads] = useState([]) // Leads

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga

  const [brandOrigin, setBrandOrigin] = useState("") // Input de búsqueda
  const [searchCriteria, setSearchCriteria] = useState("leadName") // Criterio de búsqueda

  // Búsqueda de leads
  const [leadName, setLeadName] = useState("") // Filtro de búseuqda de nombre de lead o marca
  const [leadOrigin, setLeadOrigin] = useState("") // Filtro de búsqueda de origen de lead
  const [entryOrigin, setEntryOrigin] = useState("") // Filtro de búsqueda de origen de entrada del lead
  const [responsible, setResponsible] = useState("") // Filtro de búsqueda del responsable del lead
  const [leadStage, setLeadStage] = useState("") // Filtro de búsqueda por la etapa del lead

  const [newLeadModal, setNewLeadModal] = useState(false) // Modal de nuevo lead

  const [newLeadForm, setNewLeadForm] = useState({ // Formulario de nuevo lead
    leadName: "",
    responsible: "",
    dni: "",
    ruc: "",
    brandName: "",
    position: "",
    phone: "",

    leadOrigin: "",
    entryOrigin: "",
    email: "",
    sells: "",
    ticketProduct: "",
    budget: "",
    birthday: "",
    // address: "",

    userId: null
  })

  const [dniVerify, setDniVerify] = useState(false)
  const [rucVerify, setRucVerify] = useState(false)

  const [isDniLoading, setIsDniLoading] = useState(false)
  const [isRucLoading, setIsRucLoading] = useState(false)

  const fetchDniMigo = async () => {

    if (dniVerify) {
      toast.info("El DNI ya ha sido validado");
      return;
    }

    if (newLeadForm.dni === "") {
      toast.warning("Para validar el  dni primero completa el campo")
      return;
    }

    if (newLeadForm.dni?.length !== 8) {
      toast.warning("DNI inválido");
      return;
    }

    setIsDniLoading(true);

    try {
      const response = await axios.post(
        `${API_PERU_URL}dni`,
        { dni: newLeadForm.dni },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_PERU_TOKEN}`,
          },
        }
      );

      const payload = response.data?.data;
      if (!response.data?.success || !payload?.nombre_completo) {
        toast.warning("Este DNI no existe");
        return;
      }

      setNewLeadForm((prev) => ({
        ...prev,
        leadName: payload.nombre_completo,
      }));

      toast.success("DNI validado");
      setDniVerify(true);

    } catch (error) {
      console.log(error)
      toast.warning("Este DNI no existe");
    } finally {
      setIsDniLoading(false);
    }
  };

  const fetchRUCMigo = async () => {

    if (rucVerify) {
      toast.info("El RUC ya ha sido validado");
      return;
    }

    if (newLeadForm.ruc === "") {
      toast.warning("Para validar el RUC primero completa el campo");
      return;
    }

    if (newLeadForm.ruc?.length !== 11) {
      toast.warning("RUC inválido");
      return;
    }

    setIsRucLoading(true);

    try {
      const response = await axios.post(
        `${API_PERU_URL}ruc`,
        { ruc: newLeadForm.ruc },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_PERU_TOKEN}`,
          },
        }
      );

      const payload = response.data?.data;
      if (!response.data?.success || !payload?.nombre_o_razon_social) {
        toast.warning("Este RUC no existe");
        return;
      }

      setNewLeadForm((prev) => ({
        ...prev,
        brandName: payload.nombre_o_razon_social,
      }));

      toast.success("RUC validado");
      setRucVerify(true);

    } catch (error) {
      toast.warning("Este RUC no existe");
    } finally {
      setIsRucLoading(false);
    }
  };

  const resetLeadForm = () => {
    setNewLeadForm({
      leadName: "",
      responsible: "",
      birthday: "",
      brandName: "",
      position: "",
      phone: "",
      leadOrigin: "",
      entryOrigin: "",
      dni: "",
      ruc: "",
      email: "",
      // address: "",
    })
  }

  const getLeads = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/registroLeads?limit=${limit}&page=${page}`

      if (leadName) {
        if (searchCriteria === "leadName") {
          url += `&where[leadName][contains]=${leadName}`
        } else if (searchCriteria === "phone") {
          url += `&where[phone][like]=${leadName}`
        } else if (searchCriteria === "dni") {
          url += `&where[dni][like]=${leadName}`
        } else if (searchCriteria === "id") {
          url += `&where[id][equals]=${leadName}`
        }
      }
      if (leadOrigin) {
        url += `&where[leadOrigin][equals]=${leadOrigin}`
      }
      if (entryOrigin) {
        url += `&where[entryOrigin][equals]=${entryOrigin}`
      }
      if (responsible) {
        url += `&where[responsible][equals]=${responsible}`
      }
      if (brandOrigin) {
        url += `&where[brandOrigin][equals]=${brandOrigin}`
      }
      if (leadStage) {
        url += `&where[stage][equals]=${leadStage}`
      }

      const response = await axios.get(url)

      setLeads(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (e) {
      toast.error(e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getWorkers = async () => {
    try {
      //const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true&where[area][equals]=Comercial`)
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      const sellers = response.data.docs.filter((w) => w.area === "Comercial" || w.area === "Administracion" || w.puesto === "JEFE DE MARKETING")
      setWorkers(sellers)
    } catch (e) {
      console.log(e)
    }
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setLeadName(""); // Cambiar el estado
  };

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getLeads()
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (leadName === "") {
      getLeads()
      setPage(1)
    }
  }, [leadName]);

  useEffect(() => {
    getLeads()
  }, [page, limit, leadOrigin, leadStage, entryOrigin, responsible, brandOrigin])

  const handleSubmitNewLead = async (e) => {
    try {
      e.preventDefault()
      const response = await axios.post(`${BACKEND}/api/registroLeads`, newLeadForm) // Creamos al lead

      setLeads((p) => [response.data.doc, ...p]); 

      await axios.post(`${BACKEND}/api/eventosLeads`, { // Creamos el evento de entrada al sistema del lead
        lead: response.data.doc.id,
        eventType: "Entrada al sistema",
        title: "Nuevo lead MC",
        description: "Creación lead - sistema MC",
        seller: newLeadForm.responsible
      })

      setNewLeadModal(false)
      toast.success("Lead guardado exitósamente")
    } catch (e) {
      toast.error("Error al crear el registro: " + e)
    }
  }

  const stages = [
    { name: "Leads entrantes", value: "79717403" },
    { name: "Web/Correo entrantes", value: "79869559" },
    { name: "Aún no dice que no, seguimiento por 2 días", value: "81615327" },
    { name: "Leads interesados", value: "79717407" },
    { name: "Leads no interesados", value: "79719259" },
    { name: "Muy misio", value: "79753787" },
    { name: "Llamadas programadas", value: "79719263" },
    { name: "Meets programados", value: "79717419" },
    { name: "Cotización enviada (prospecto)", value: "79717411" },
    { name: "Me rendí", value: "81439775" },
    { name: "Prospecto a futuro", value: "81617899" },
    { name: "Perdieron interés (prospecto)", value: "79719267" },
    { name: "Trabaja en otra agencia / Freelance", value: "81615803" },
  ]

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal // Modal para leads
        activeModal={newLeadModal}
        onClose={() => {
          setNewLeadModal(false)
          resetLeadForm()
          setDniVerify(false)
          setRucVerify(false)
        }}
        title="Crear nuevo Lead"
        className="max-w-3xl"
        centered
      >
        <form 
          className="max-h-[75vh] overflow-y-auto"
          onSubmit={(e) => handleSubmitNewLead(e)}
        >
          <div className="flex flex-row gap-4">

            <div className="flex flex-col w-1/2">

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Nombre
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaUser />
                  </span>
                  <input
                    type="text"
                    placeholder="Nombre del lead"
                    value={newLeadForm.leadName}
                    required
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, leadName: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Responsable
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaUserCircle />
                  </span>
                  <select
                    type="text"
                    placeholder="Responsable del lead"
                    value={newLeadForm.responsible}
                    required
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, responsible: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  >
                    <option value={""}>Seleccionar</option>
                    {workers.map((worker) => (
                      <option value={worker.id}>{worker.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    DNI
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaIdCard />
                  </span>
                  <input
                    type="text"
                    placeholder="DNI del lead"
                    required
                    value={newLeadForm.dni}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, dni: e.target.value}))}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />

                  {dniVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={fetchDniMigo}
                      disabled={isDniLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                    >
                      {isDniLoading ? (
                        <FormLoader colour={"#F64000"} className={" w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    RUC
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="RUC del lead"
                    required
                    value={newLeadForm.ruc}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, ruc: e.target.value}))}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                  {rucVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={fetchRUCMigo}
                      disabled={isRucLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                    >
                      {isRucLoading ? (
                        <FormLoader colour={"#F64000"} className={" w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Marca
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaPhoenixFramework />
                  </span>
                  <input
                    type="text"
                    placeholder="Nombre de la marca o empresa del lead"
                    value={newLeadForm.brandName}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, brandName: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Puesto o posición
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaSuitcase />
                  </span>
                  <input
                    type="text"
                    placeholder="Puesto del lead en su empresa"
                    value={newLeadForm.position}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, position: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Teléfono
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaPhone />
                  </span>
                  <input
                    type="text"
                    placeholder="Número del lead"
                    value={newLeadForm.phone}
                    required
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, phone: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

            </div>

            <div className="flex flex-col w-1/2">

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Origen del lead
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaNetworkWired />
                  </span>
                  <select
                    type="text"
                    value={newLeadForm.leadOrigin}
                    required
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, leadOrigin: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  >
                    <option value={"Sin definir"}>Sin definir</option>

                    <option value={"Orgánico"}>Orgánico</option>
                    <option value={"Web orgánico"}>Web orgánico</option>

                    <option value={"Facebook Ads"}>Facebook Ads</option>
                    <option value={"Google Ads"}>Google Ads</option>
                    <option value={"Linkedin Ads"}>Linkedin Ads</option>
                    <option value={"Tiktok Ads"}>Tiktok Ads</option>
                    <option value={"Youtube Ads"}>Youtube Ads</option>

                    <option value={"Facebook"}>Facebook</option>
                    <option value={"Google"}>Google</option>
                    <option value={"Linkedin"}>Linkedin</option>
                    <option value={"Tiktok"}>Tiktok</option>
                    <option value={"Youtube"}>Youtube</option>
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Origen de entrada del lead
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaNetworkWired />
                  </span>
                  <select
                    type="text"
                    value={newLeadForm.entryOrigin}
                    required
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, entryOrigin: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  >
                    <option value={""}>Seleccionar</option>
                    <option value={"Kommo"}>Kommo</option>
                    <option value={"WhatsApp"}>WhatsApp</option>
                    <option value={"Llamada"}>Llamada</option>
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Email
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaVoicemail />
                  </span>
                  <input
                    type="text"
                    placeholder="Email del lead"
                    value={newLeadForm.email}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, email: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    ¿Qué vende?
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaBox />
                  </span>
                  <input
                    type="text"
                    placeholder="Que vende el lead"
                    value={newLeadForm.sells}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, sells: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Ticket del producto
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaMoneyBillAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="Ticket del producto del lead"
                    value={newLeadForm.ticketProduct}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, ticketProduct: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Presupuesto
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaMoneyBillTrendUp />
                  </span>
                  <input
                    type="text"
                    placeholder="Presupuesto del lead"
                    value={newLeadForm.budget}
                    onChange={(e) => setNewLeadForm((prev) => ({...prev, budget: e.target.value}))}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="text-xs block text-gray-700 mb-2">
                    Cumpleaños
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaBirthdayCake />
                  </span>
                  <input
                    type="date"
                    placeholder="Cumpleaños del lead"
                    value={newLeadForm.birthday ? new Date(newLeadForm.birthday).toISOString().split("T")[0] : ""}
                    onChange={(e) => {
                      const isoDate = new Date(e.target.value).toISOString();
                      setNewLeadForm((prev) => ({ ...prev, birthday: isoDate }));
                    }}
                    className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                </div>
              </div>

            </div>

          </div>

          <Button 
            variant="contained"
            type="submit"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              marginTop: "20px",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
          >
            Guardar
          </Button>
        
        </form>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaUser className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Historial de leads</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            {isSuperAdmin && (
              <ExportarColeccionExcel collecion="registroLeads" />
            )}

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Buscar por:</span>
              <select
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
                <option value="id">ID</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar lead"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={leadName}
                onChange={(e) => setLeadName(e.target.value)}
              />
              {leadName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>
          </div>

        </div>
      </div>

      {/* FilterBar */}
      <div className="flex bg-gray-100 mt-1 mb-1 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-between overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-4 items-center justify-center">
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Origen de lead:</span>
              <select
                value={leadOrigin}
                onChange={(e) => setLeadOrigin(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Seleccionar</option>
                <option value={"Facebook Ads"}>Facebook Ads</option>
                <option value={"Google Ads"}>Google Ads</option>
                <option value={"Linkedin Ads"}>Linkedin Ads</option>
                <option value={"Tiktok Ads"}>Tiktok Ads</option>
                <option value={"Youtube Ads"}>Youtube Ads</option>
                <option value={"Web orgánico"}>Web orgánico</option>
                <option value={"Facebook"}>Facebook</option>
                <option value={"Google"}>Google</option>
                <option value={"Linkedin"}>Linkedin</option>
                <option value={"Tiktok"}>Tiktok</option>
                <option value={"Youtube"}>Youtube</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Origen de entrada:</span>
              <select
                value={entryOrigin}
                onChange={(e) => setEntryOrigin(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Seleccionar</option>
                <option value={"Kommo"}>Kommo</option>
                <option value={"WhatsApp"}>WhatsApp</option>
                <option value={"Llamada"}>Llamada</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Responsable:</span>
              <select
                value={responsible}
                onChange={(e) => setResponsible(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value="">Seleccionar</option>
                {workers.map((worker) => (
                  <option value={worker.id}>{worker.name}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Etapa:</span>
              <select
                value={leadStage}
                onChange={(e) => setLeadStage(e.target.value)}
                className="text-gray-700 w-[150px] hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px]"
              >
                <option value={""}>Todos</option>
                {stages.map((s) => (
                  <option value={s.value}>{s.name}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate">Origen marca:</span>
              <select
                value={brandOrigin}
                onChange={(e) => setBrandOrigin(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
              >
                <option value={""}>Seleccionar</option>
                <option value={"Sin definir"}>Sin definir</option>
                <option value={"Mundo Digital"}>Mundo Digital</option>
                <option value={"Allsavfe"}>Allsavfe</option>
                <option value={"W3P"}>W3P</option>
                <option value={"Monstruo Creativo"}>Monstruo Creativo</option>
                <option value={"SEOluciones"}>SEOluciones</option>
                <option value={"Nodo"}>Nodo</option>
                <option value={"Aura BTL"}>Aura BTL</option>
                <option value={"Conviertelo"}>Conviertelo</option>
                <option value={"Lucuma"}>Lucuma</option>
              </select>
            </div>
          </div>

          <div className="pl-4">
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                padding: "3px 24px",
                whiteSpace: "nowrap",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
              onClick={() => setNewLeadModal(true)}
            >
              Crear nuevo lead
            </Button>
          </div>
        </div>
      </div>
      
      {/* Body */}
      <div className={`flex-grow overflow-y-auto`}>
      {/* <div className=" flex-grow overflow-y-auto "> */}
        {loadingStatus ? (
            <LoadingScreen />
          ) : (
            leads.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full">
                <thead className="bg-white sticky top-0">
                  <tr className="text-gray-700 text-center text-[10px] font-bold">
                    <th className="px-6 py-4 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-4 items-center justify-center w-full">
                        <Tooltip content="Eliminar lead">
                          <div className="font-bold hover:underline transition-all duration-100 text-white">
                            <FaTrash />
                          </div>
                        </Tooltip>
                        <Tooltip content="Ver trackeo del lead">
                          <div className="font-bold hover:underline transition-all duration-100 text-white">
                            <FaExternalLinkAlt />
                          </div>
                        </Tooltip>
                        <Tooltip content="Ver trackeo del lead">
                          <div className="font-bold hover:underline transition-all duration-100 text-white">
                            <FaBarcode />
                          </div>
                        </Tooltip>
                      </div>
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Nombre lead
                    </th>
                    <th className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      <span className="block truncate">Responsable Kommo CRM </span>{"\n"}
                      <span className="block truncate">Actualizar desde Kommo</span>
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha de entrada
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Teléfono
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Email
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      País
                    </th>
                    <th className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      DNI 
                      <span className="block truncate">Actualizar desde Kommo</span>
                    </th>
                    <th className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                      RUC
                      <span className="block truncate">Actualizar desde Kommo</span>
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      ID en Kommo
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Origen de entrada
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Origen de marca
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Origen de lead
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Etapa
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      ¿Qué vende?
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Ticket
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Presupuesto
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Nombre de marca
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Puesto
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead) => (
                    <ItemRowLead
                      lead={lead}
                      setLeads={setLeads}
                      workers={workers}
                      setLeadName={setLeadName}
                      countryNames={countryNames}
                      stages={stages}
                    />
                  ))}
                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={leads.length}
        totalDocs={totalDocs}
        entity={"leads"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  )
}

export default TrackeoLeads